import { makeStyles } from '@material-ui/core'
import { NavLink } from 'Core'
import useAppView from 'Core/Hooks/useAppView'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
const useStyle = makeStyles({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  }
})
function NotFound() {
  const classes = useStyle()
  const history = useHistory()
  const { appView } = useAppView()

  useEffect(() => {
    if (appView === 'user') {
      history.replace('/user/targets')
    }
  }, [appView])

  if (appView === 'user') return null

  return (
    <div className={classes.root}>
      <h3>The Route You Are Looking For Is Not Found.</h3>
      <NavLink to={`/${appView}`}>Go back to Home</NavLink>
    </div>
  )
}

export { NotFound }
